<template>
  <div id="app">
    <!--路由占位符-->
    <router-view></router-view>
    <Footer />
  </div>
</template>

<script>

import Footer from './components/Footer'

export default {
  name: 'app',
  components: { Footer }
}
</script>

<style>
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

/*美化滚动条*/
::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 0;
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-thumb {
  cursor: pointer;
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.15);
  transition: color 0.2s ease;
}
</style>
